import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { NAV_ITEMS } from '../data/site';
import { AgreexaMark } from './AgreexaMark';
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 bg-paper/90 backdrop-blur-md border-b border-stone-200" data-id="element-166">
      {/* Powered-by top bar */}
      <div className="bg-ink text-paper" data-id="element-167">
        <div className="max-w-editorial mx-auto px-6 py-2 flex items-center justify-center gap-2" data-id="element-168">
          <span className="eyebrow text-stone-400" style={{
          fontSize: '0.6rem'
        }} data-id="element-169">
            Powered by
          </span>
          <AgreexaMark tone="light" className="text-xs" data-id="element-170" />
          <span className="hidden sm:inline text-stone-400 text-[0.65rem] tracking-wide" data-id="element-171">
            — The Global Trust Infrastructure
          </span>
        </div>
      </div>

      {/* Masthead */}
      <div className="max-w-editorial mx-auto px-6 py-5 flex items-center justify-between" data-id="element-172">
        <Link to="/" className="group" data-id="element-173">
          <span className="block font-serif tracking-tightest text-ink text-2xl md:text-3xl leading-none" style={{
          fontWeight: 600
        }} data-id="element-174">
            Home Independence Hub
            <sup className="text-[0.5em] align-super ml-0.5" data-id="element-175">™</sup>
          </span>
          <span className="eyebrow text-trust-600 mt-1 block" style={{
          fontSize: '0.6rem'
        }} data-id="element-176">
            Smart Solutions for an Independent Home
          </span>
        </Link>

        <button className="lg:hidden p-2 -mr-2 text-ink" onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-177">
          {open ? <XIcon className="h-6 w-6" data-id="element-178" /> : <MenuIcon className="h-6 w-6" data-id="element-179" />}
        </button>
      </div>

      {/* Primary nav */}
      <nav className="hidden lg:block border-t border-stone-200" aria-label="Primary" data-id="element-180">
        <ul className="max-w-editorial mx-auto px-6 flex items-center gap-7" data-id="element-181">
          {NAV_ITEMS.map(item => <li key={item.to + item.label} data-id="element-182">
              <NavLink to={item.to} end={item.to === '/'} className={({
            isActive
          }) => `inline-block py-3 text-[0.8rem] font-500 tracking-wide transition-colors ${isActive ? 'text-trust-700 border-b-2 border-trust-600 -mb-px' : 'text-stone-600 hover:text-ink'}`} data-id="element-183">
                {item.label}
              </NavLink>
            </li>)}
        </ul>
      </nav>

      {/* Mobile nav */}
      {open && <nav className="lg:hidden border-t border-stone-200 bg-paper" aria-label="Mobile" data-id="element-184">
          <ul className="max-w-editorial mx-auto px-6 py-2" data-id="element-185">
            {NAV_ITEMS.map(item => <li key={item.to + item.label} data-id="element-186">
                <NavLink to={item.to} end={item.to === '/'} onClick={() => setOpen(false)} className={({
            isActive
          }) => `block py-3 border-b border-stone-100 text-sm font-500 ${isActive ? 'text-trust-700' : 'text-stone-700'}`} data-id="element-187">
                  {item.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>}
    </header>;
}